module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"search_coupons":"Search coupons","create_new_coupon":"Create New Coupon","coupons_not_found":"Coupons not found or empty"},"id":{"search_coupons":"Cari kupon","create_new_coupon":"Buat Kupon Baru","coupons_not_found":"Coupons not found or empty"}}')
  delete Component.options._Ctor
}
